<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousPoView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Air Freight Export</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-button-group size="sm">
              <b-button :disabled="AIR_BOOK == '0' ? true : false" @click="gotToPage('BOOK')"
                :variant="AIR_BOOK == '0' ? '' : 'success'">Booking</b-button>
              <b-button :disabled="AIR_EXEC == '0' ? true : false" @click="gotToPage('EXEC')"
                :variant="AIR_EXEC == '0' ? '' : 'success'">Execution</b-button>
              <b-button :disabled="AIR_TRACK == '0' ? true : false" @click="gotToPage('TRACK')"
                :variant="AIR_TRACK == '0' ? '' : 'success'">Tracking</b-button>

              <!--<b-button disabled>BL</b-button> -->
            </b-button-group>
          </b-navbar-nav>
        </b-navbar>
        <banner-component :allModuleIdBanner="
            this.AirFreightMain.allModuleId ? this.AirFreightMain.allModuleId : ''
          " :jobSeriesBanner="
            this.AirFreightMain.airFFExportSeries
              ? this.AirFreightMain.airFFExportSeries
              : ''
          " :bannerClientName="
            this.allShipperData[0].clientName ? this.allShipperData[0].clientName : ''
          " iconId="fa fa-ship" />
        <b-card class="formCard">
          <b-card-text>
            <!-- <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="90"></md-layout>
              <md-layout md-flex="10">
                <md-button
                  v-if="AirFreightMain.airFcExportId"
                  @click="addStatus"
                  style="position: fixed;z-index:999;top:83%;"
                  class="md-fab"
                >
                  <md-icon>message</md-icon>
                </md-button>
              </md-layout>
            </md-layout> -->

            <div>
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="20">
                  <label for="shipmentType">Shipping Type</label>

                  <model-list-select :list="shipmentTypeList" v-model="AirFreightMain.shipmentType"
                    option-value="shipmentTypeVal" option-text="shipmentTypeText" placeholder="Select Shipment Type"
                    isDisabled></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label for="transportType">Export</label>

                  <model-list-select :list="transportTypeList" v-model="AirFreightMain.transportType"
                    option-value="transportTypeVal" option-text="transportTypeText" placeholder="Select Transport Type"
                    isDisabled></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="20">
                  <label for="airFFType">FF Activity Type</label>

                  <model-list-select isDisabled :list="containerInfoList" v-model="AirFreightMain.airFFType"
                    option-value="containerInfoVal" option-text="containerInfoText"
                    placeholder="Select FF Activity"></model-list-select>
                  <span class="error" v-if="!AirFreightMain.airFFType">{{
                    mainErrorList.airFFType
                    }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="25">
                  <label for="shipmentExecution">Shipment Execution</label>

                  <model-list-select :list="shipmentExectionList" v-model="AirFreightMain.shipmentExecution"
                    option-value="shipmentExectionVal" option-text="shipmentExectionTxt"
                    placeholder="Select Shipment Exec"></model-list-select>
                  <span class="error" v-if="!AirFreightMain.shipmentExecution">{{
                    mainErrorList.shipmentExecution
                    }}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="25" md-flex-small="100" class="gutr">
                  <label for="containerTypeId">Airline</label>
                  <model-list-select isDisabled :list="airLineList" v-model="AirFreightMain.airlineId"
                    option-value="airlineId" option-text="airlineName" placeholder="Select Airline"></model-list-select>
                  <!-- <span
                      class="error"
                      v-if="!ffExoprtDetail.transContainerTypeId"
                  >{{transContainerTypeIdError}}</span>-->
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="35">
                  <label for="airportDeparture">Departure Airport</label>

                  <model-list-select isDisabled @input="getLocationList($event, 'Air_Port', 'getPortDischargeList')"
                    @searchchange="
                      getLocationList($event, 'Air_Port', 'getPortDischargeList')
                    " :list="getPortDischargeList" v-model="AirFreightMain.airportDeparture" option-value="pickupId"
                    option-text="pickupLocation" placeholder="Select Airport"></model-list-select>
                  <span class="error" v-if="!AirFreightMain.airportDeparture">{{
                    mainErrorList.airportDeparture
                    }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="30">
                  <label for="airportDestination">Destination Airport</label>

                  <model-list-select isDisabled @input="getLocationList($event, 'Air_Port', 'PortDestiList')"
                    @searchchange="getLocationList($event, 'Air_Port', 'PortDestiList')" :list="PortDestiList"
                    v-model="AirFreightMain.airportDestination" option-value="pickupId" option-text="pickupLocation"
                    placeholder="Select Airport"></model-list-select>
                  <span class="error" v-if="!AirFreightMain.airportDestination">{{
                    mainErrorList.airportDestination
                    }}</span>
                </md-layout>
              </md-layout>
            </div>

            <md-layout class="gutr" md-gutter v-if="
                AirFreightMain.airFFType == 'fclConsolidation' &&
                consoMultipleShipperTable.length > 0 &&
                airFreightModal.shipperFreightId == ''
              ">
              <md-layout md-flex="85"></md-layout>

              <md-layout md-flex="15">
                <b-button @click="showMoreShipper" variant="outline-info" size="sm">{{ openShipper == true ? "Hide" :
                  "Add More" }} Clients</b-button>

                <md-spinner md-indeterminate id="loader1" style="display: none"></md-spinner>
              </md-layout>
            </md-layout>

            <b-card class="mt-3">
              <div class="box" v-if="consoMultipleShipperTable.length > 0">
                <h5>
                  <b-badge>Client Details</b-badge>
                </h5>

                <!-- /.box-header -->
                <div class="box-body">
                  <table id="shiper" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr.no</th>

                        <th>Client Name</th>

                        <th>Cargo Details</th>

                        <th>Other Details</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(item1, index) in consoMultipleShipperTable" :key="index">
                        <td>{{ index + 1 }}</td>

                        <td class="showMoreData" @click="viewEditShiper(item1)">
                          {{ item1.clientName }}
                        </td>

                        <td>
                          <span>
                            Cargo Received At : {{ item1.cargoReceivedAt }}
                            <br />
                          </span>

                          <span>
                            Cargo Gross Weight : {{ item1.cargoGrossWeight }}
                            {{ item1.CargowgtUnit }}
                            <br />
                          </span>
                          <span>
                            Cargo Volume Weight : {{ item1.cargoVolumeWeight }}
                            <br />
                          </span>
                        </td>
                        <span>
                          CC Type : {{ item1.ccType }}
                          <br />
                        </span>
                        <span>
                          Delivery Mode : {{ item1.deliveryMode }}
                          <br />
                        </span>
                        <span>
                          Delivery Terms : {{ item1.deliveryTerms }}
                          <br />
                        </span>
                        <span>
                          Chargeable Vol. Wgt. by System : {{ item1.chargeVolWgtSys }}
                          <br />
                        </span>
                        <span>
                          Chargeable Vol. Wgt. by Airline : {{ item1.chargeVolWgtAir }}
                          <br />
                        </span>
                        <span>
                          Final Chargeable Wgt. : {{ item1.finalChargableWeight }}
                          <br />
                        </span>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- /.box-body -->
              </div>
              <div v-if="
                  consoMultipleShipperTable.length <= 0 ||
                  airFreightModal.shipperFreightId != '' ||
                  openShipper == true
                ">
                <!-- <md-layout md-gutter v-if="AirFreightMain.airFFType=='fclConsolidation'">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15">
                      <h4 style="margin-top:16px">
                        <u>Shipper Details</u>
                      </h4>
                    </md-layout>
                  </md-layout>-->
                <b-card class="gutr" style="background: whiteSmoke">
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="25">
                      <label for="clientId">Existing Client Name</label>

                      <model-list-select :isDisabled="
                          airFreightModal.shipperFreightId == '' ? false : true
                        " :list="clientList" id="clientNamenew" v-model="airFreightModal.clientId"
                        option-value="clientId" option-text="clientName"
                        placeholder="Select Existing Client Name"></model-list-select>
                      <span class="error" v-if="!airFreightModal.clientId">{{
                        shipperErrorList.clientId
                        }}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="10">
                      <label for="stuffingType">No.of Pkg</label>

                      <b-form-input :formatter="capitalizeAll" id="fff" name="bfffuyer"
                        v-model="airFreightModal.noOfPackageUnit"></b-form-input>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15">
                      <label for="stuffingType">Cargo Received At</label>

                      <model-list-select :list="stuffingTypeList" v-model="airFreightModal.cargoReceivedAt"
                        option-value="stuffingTypeVal" option-text="stuffingTypeText"
                        placeholder="Select Received At"></model-list-select>
                      <span class="error" v-if="!airFreightModal.cargoReceivedAt">{{
                        shipperErrorList.cargoReceivedAt
                        }}</span>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15" v-if="airFreightModal.cargoReceivedAt === 'pickup'">
                      <md-layout md-flex="100">
                        <label for="pickup_location">Pickup Location</label>
                        <b-form-input :formatter="capitalizeAll" id="pickup_location" name="pickup_location"
                          v-model="airFreightModal.pickup_location"></b-form-input>
                      </md-layout>
                      <span class="error" v-if="airFreightModal.pickup_location_err ? true : false">
                        {{ airFreightModal.pickup_location_err }}
                      </span>
                    </md-layout>

                    <md-layout md-flex="5" v-if="airFreightModal.cargoReceivedAt === 'pickup'"></md-layout>

                    <md-layout md-flex="15">
                      <label for="shipmentType">Source Of Booking</label>

                      <!-- bookingSource is for source of booking -->
                      <model-list-select :list="bookingSourceList" v-model="airFreightModal.bookingSource"
                        option-value="bookingSourceVal" option-text="bookingSourceText"
                        placeholder="Select Source Of Booking "></model-list-select>
                      <span class="error" v-if="!airFreightModal.bookingSource">{{
                        shipperErrorList.bookingSource
                        }}</span>
                    </md-layout>
                  </md-layout>

                  <md-layout gutter class="labelMargtop">
                    <md-layout md-flex="45">
                      <label>Type of Airway</label>
                      <model-list-select option-value="value" option-text="text" :list="AirwayType"
                        placeholder="Select B/L" v-model="airFreightModal.typeAirway"></model-list-select>
                      <span class="error" v-if="!airFreightModal.typeAirway">{{
                        shipperErrorList.typeAirway
                        }}</span>
                    </md-layout>
                    <md-layout md-flex="5" v-if="airFreightModal.typeAirway == 'HouseAirwayBL'"></md-layout>
                    <md-layout md-flex="20" v-if="airFreightModal.typeAirway == 'HouseAirwayBL'">
                      <label>Freight Terms For HAWB</label>
                      <model-list-select option-value="value" option-text="text" :list="freightTerms"
                        placeholder="Select Terms" v-model="airFreightModal.HAWBTerms"></model-list-select>
                      <span class="error" v-if="!airFreightModal.HAWBTerms">{{
                        HAWBTermsError
                        }}</span>
                    </md-layout>
                    <md-layout md-flex="5" v-if="airFreightModal.typeAirway == 'HouseAirwayBL'"></md-layout>
                    <md-layout md-flex="25" v-if="airFreightModal.typeAirway == 'HouseAirwayBL'">
                      <label>Freight Terms For MAWB</label>
                      <model-list-select option-value="value" option-text="text" :list="freightTerms"
                        placeholder="Select Terms" v-model="airFreightModal.MAWBTerms"></model-list-select>
                      <span class="error" v-if="!airFreightModal.MAWBTerms">{{
                        MAWBTermsError
                        }}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20" v-if="airFreightModal.typeAirway == 'DirectAirwayBL'">
                      <label>Freight Terms</label>
                      <model-list-select option-value="value" option-text="text" :list="freightTerms"
                        placeholder="Select Terms" v-model="airFreightModal.freightTerms"></model-list-select>
                      <span class="error" v-if="!airFreightModal.freightTerms">{{
                        freightTermsError
                        }}</span>
                    </md-layout>
                  </md-layout>

                  <!-- <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="15">
              <h4 style="margin:0px" class="showMoreData" @click="addNew">Add New Client</h4>
            </md-layout>
                    </md-layout>-->
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="45" v-if="airFreightModal.bookingSource == 'Destination'">
                      <label for="agentName">Agent Name</label>

                      <model-list-select :list="agentNameList" v-model="airFreightModal.agentName"
                        option-value="agntColoaderId" option-text="agentName"
                        placeholder="Select Agent Name"></model-list-select>
                    </md-layout>

                    <md-layout md-flex="45" v-if="airFreightModal.bookingSource == 'Origin'">
                      <label for="sourceOriginclientId">Client Name</label>

                      <model-list-select :list="clientList" id="clientNamenew"
                        v-model="airFreightModal.sourceOriginclientId" option-value="clientId" option-text="clientName"
                        placeholder="Select Client Name"></model-list-select>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="50" v-if="airFreightModal.bookingSource == 'Destination'">
                      <md-layout md-flex="100">
                        <label>Buyer Name</label>

                        <b-form-input :formatter="capitalizeAll" id="buyer" name="buyer"
                          v-model="airFreightModal.buyer"></b-form-input>
                      </md-layout>
                    </md-layout>

                    <md-layout md-flex="20" v-if="airFreightModal.bookingSource == 'Origin'">
                      <md-layout md-flex="100">
                        <label>Buying House</label>

                        <b-form-input :formatter="capitalizeAll" id="buyingHouse" name="buyingHouse"
                          v-model="airFreightModal.buyingHouse"></b-form-input>
                      </md-layout>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="25" v-if="airFreightModal.bookingSource == 'Origin'">
                      <md-layout md-flex="100">
                        <label>Other Specify</label>

                        <b-form-input :formatter="capitalizeAll" id="otherSpecify" name="otherSpecify"
                          v-model="airFreightModal.otherSpecify"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="45">
                      <label for="ccType">CC Type</label>

                      <model-list-select :list="cctypeList" v-model="airFreightModal.ccType" option-value="ccTypeVal"
                        option-text="ccTypeTxt" placeholder="Select CC Type"></model-list-select>
                    </md-layout>

                    <md-layout md-flex="5" v-if="airFreightModal.ccType == 'Outsourced'"></md-layout>

                    <md-layout md-flex="50" v-if="airFreightModal.ccType == 'Outsourced'">
                      <md-layout md-flex="100">
                        <label>CHA Name</label>

                        <model-list-select :list="chaNameList" v-model="airFreightModal.ccCha"
                          option-value="agntColoaderId" option-text="agentName"
                          placeholder="Select CHA "></model-list-select>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="45">
                      <label for="deliveryMode">Destination Delivery Mode</label>

                      <model-list-select :list="deliveryModeList" v-model="airFreightModal.deliveryMode"
                        option-value="deliveryModeVal" option-text="deliveryModeText"
                        placeholder="Select Delivery Mode"></model-list-select>
                      <span class="error" v-if="!airFreightModal.deliveryMode">{{
                        shipperErrorList.deliveryMode
                        }}</span>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15" v-if="airFreightModal.deliveryMode === 'fpod'">
                      <md-layout md-flex="100">
                        <label for="fpod_location">FPOD Location</label>
                        <b-form-input :formatter="capitalizeAll" id="fpodLocation" name="fpod_location"
                          v-model="airFreightModal.fpod_location"></b-form-input>
                      </md-layout>
                      <span class="error" v-if="airFreightModal.fpod_location_err ? true : false">
                        {{ airFreightModal.fpod_location_err }}
                      </span>
                    </md-layout>

                    <md-layout md-flex="5" v-if="airFreightModal.deliveryMode === 'fpod'"></md-layout>

                    <md-layout md-flex="50" v-if="airFreightModal.deliveryMode == 'Door'">
                      <label for="doorFpod">Final Place of Delivery</label>

                      <model-list-select @input="getLocationList($event, 'Air_Port', 'finalAllPlaceData')"
                        @searchchange="
                          getLocationList($event, 'Air_Port', 'finalAllPlaceData')
                        " :list="finalAllPlaceData" v-model="airFreightModal.doorFpod" option-value="pickupId"
                        option-text="pickupLocation" placeholder="Select FPOD"></model-list-select>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="100" v-if="airFreightModal.deliveryMode == 'Door'">
                      <label for="deliveryMode">Door Add</label>
                      <b-form-textarea :formatter="capitalizeAll" rows="5" id="name-input"
                        v-model="airFreightModal.door_add" required></b-form-textarea>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="45">
                      <label for="deliveryTerms">Delivery Terms(INCOTERMS)</label>

                      <model-list-select :list="deliveryTermsList" v-model="airFreightModal.deliveryTerms"
                        option-value="deliveryTermsVal" option-text="deliveryTermsText"
                        placeholder="Select Delivery Terms"></model-list-select>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="45">
                      <label for="autoCommodity">Commodity</label>

                      <model-list-select :list="commodityList" v-model="airFreightModal.commodityId"
                        option-value="commodityId" option-text="itemDescription"
                        placeholder="Select Commodity"></model-list-select>
                      <span class="error" v-if="!airFreightModal.commodityId">{{
                        shipperErrorList.commodityId
                        }}</span>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="50">
                      <md-layout md-flex="100">
                        <label for="commodityType">Commodity Type</label>

                        <b-form-input :formatter="capitalizeAll" id="commodityType" name="commodityType" disabled
                          v-model="airFreightModal.commodityType"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter style="margin-top: 10px" v-if="airFreightModal.commodityType == 'Hazardous'">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>IMDG Class</label>

                        <b-form-input :formatter="capitalizeAll" id="IMDGClass" name="IMDGClass"
                          v-model="airFreightModal.IMDGClass"></b-form-input>
                      </md-layout>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>UN Number</label>

                        <b-form-input :formatter="capitalizeAll" id="UNNumber" name="UNNumber"
                          v-model="airFreightModal.UNNumber"></b-form-input>
                      </md-layout>
                    </md-layout>

                    <md-layout md-flex="10"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Packing Code</label>

                        <b-form-input :formatter="capitalizeAll" id="packingCode" name="packingCode"
                          v-model="airFreightModal.packingCode"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter style="margin-top: 10px" v-if="airFreightModal.commodityType == 'Reefer'">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Temperature Req(Degree Celsius)</label>

                        <b-form-input :formatter="capitalizeAll" id="temperatureRequired" name="temperatureRequired"
                          v-model="airFreightModal.temperatureRequired"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="gutr" v-if="airFreightModal.commodityType == 'Others'">
                    <md-layout md-flex="90">
                      <md-layout md-flex="100">
                        <label>Specific Detail if any..!</label>

                        <b-form-input :formatter="capitalizeAll" id="otherComodity" name="otherComodity"
                          v-model="airFreightModal.otherComodity"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="mt-3">
                    <md-layout md-flex="15">
                      <h5>
                        <b-badge>Additional Task</b-badge>
                      </h5>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter>
                    <md-layout v-for="(otherServiceNameArray, index) in showOtherServiceArray" :key="index"
                      :md-flex="otherServiceNameArray.flex">
                      <md-checkbox v-model="airFreightModal.otherServices[index]" class="md-primary"
                        :md-value="otherServiceNameArray.value" :name="'otherServices' + (index + 1)"
                        :id="'otherServices' + (index + 1)" @change="
                          otherServiceNameArraySelect(otherServiceNameArray.value, index)
                        "></md-checkbox>
                      <span style="margin-top: 17px">{{
                        otherServiceNameArray.show
                        }}</span>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter>
                    <!-- <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="50">
                        <md-input-container>
                          <label
                            style="margin-top:-17px"
                            for="additionalMoreTask"
                          >More Additional Task</label>

                          <md-select
                            name="additionalMoreTask"
                            id="additionalMoreTask"
                            multiple
                            v-model="airFreightModal.additionalMoreTask"
                            @change="showMultiple"
                          >
                            <md-option
                              v-for="(AdditionalMoreArray,index) in showAdditionalMoreTaskArray"
                              :key="index"
                              :value="AdditionalMoreArray"
                            >{{AdditionalMoreArray.show}}</md-option>
                          </md-select>
                        </md-input-container>
                      </md-layout>-->
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="35" v-if="showAdd == true">
                      <md-layout md-flex="100">
                        <label>Specify Additional Task</label>

                        <b-form-input :formatter="capitalizeAll" id="specificAdditionalTask"
                          name="specificAdditionalTask" v-model="airFreightModal.specificAdditionalTask"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <div>
                    <b-button variant="primary" size="sm" class="pull-right smbutnWidth" id="addButtonLoaderMid"
                      @click="addMainWithShipper">{{
                      airFreightModal.shipperFreightId != "" ? "Save" : "Save"
                      }}</b-button>

                    <md-spinner md-indeterminate id="loaderMid" style="display: none"></md-spinner>
                  </div>
                </b-card>
              </div>
            </b-card>

            <div v-if="allShipperData.length > 0">
              <b-card class="mt-3" v-if="showPackageSection != null && showPackageSection != ''">
                <div>
                  <b-button v-if="AirFreightMain.airFFType == 'fclConsolidation'" variant="outline-success" size="sm"
                    @click="addPackModal('1')">Add Package For Another Client</b-button>
                </div>
                <div class="box" v-if="packageDetails.length > 0">
                  <div>
                    <h5>
                      <b-badge>Package Details</b-badge>
                    </h5>

                    <!-- <span
                        class="pull-right"
                        style="color:blue;font-size:14px;margin-right:5%"
                        v-if="airPackageModal.shipperFreightId!=''"
                      >Total Volume Weight of Cargo = {{totalPackageVolume}}</span>-->
                    <!-- <span
                        class="pull-right"
                        style="color:blue;font-size:14px;margin-right:5%"
                        v-if="airPackageModal.shipperFreightId!=''"
                      >Total No. of Package = {{totalPackage}}</span>-->
                  </div>

                  <!-- /.box-header -->
                  <div class="box-body">
                    <table id="portLocationNew" class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sr.no</th>

                          <th>Client Name</th>

                          <th>No.of Package</th>

                          <th>Package Length</th>

                          <th>Package Width</th>

                          <th>Package Height</th>

                          <th>Unit</th>

                          <th>Package Volume</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="(item1, index) in packageDetails" :key="index">
                          <td>{{ index + 1 }}</td>

                          <td>{{ item1.clientName }}</td>

                          <td>{{ item1.noOfPackage }}</td>

                          <td>{{ item1.packageLength }}</td>

                          <td>{{ item1.packageWidth }}</td>

                          <td>{{ item1.packageHeight }}</td>

                          <td>{{ item1.packageUnit }}</td>

                          <td>{{ item1.packageVolume }}</td>
                          <td>
                            <b-button size="sm" variant="outline-danger" @click="viewEditPackage(item1)">Edit
                              Package</b-button>
                            <b-button size="sm" variant="outline-danger" @click="removeCommon(item1)">Delete</b-button>
                            <!-- @click="DeleteList(item1.cargoId)" -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- /.box-body -->
                </div>
                <!-- <md-layout md-gutter>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="15">
                  <label>
                    <u>Package Details</u>
                  </label>
                </md-layout>
                  </md-layout>-->
                <div>
                  <b-modal :size="showPakg == false ? 'xl' : ''" no-close-on-esc no-close-on-backdrop scrollable
                    id="myDIV" hide-footer ref="packagePop" title="Package Details">
                    <div class="d-block text-center">
                      <b-card>
                        <b-card-text>
                          <md-layout md-gutter>
                            <md-layout md-flex="50">
                              <label for="sourceOriginclientId">Client Name</label>

                              <model-list-select :list="packageClientList" id="clientNamenew"
                                v-model="airPackageModal.shipperFreightId" option-value="shipperFreightId"
                                option-text="clientName" placeholder="Select Client Name"
                                :isDisabled="airPackageModal.cargoId != '' ? true : false"></model-list-select>

                              <span class="error" v-if="!airPackageModal.shipperFreightId">{{
                                packageErrorList.shipperFreightId }}</span>
                            </md-layout>

                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="40" v-if="airPackageModal.shipperFreightId != ''">
                              <label>Total Packages of Client</label>

                              <b-form-input :formatter="capitalizeAll" :disabled="
                                  AirFreightMain.airFFType == 'fclConsolidation'
                                    ? false
                                    : true
                                " id="noOfPackageUnit" name="noOfPackageUnit" type="number"
                                v-model="airPackageModal.noOfPackageUnit"></b-form-input>
                              <span class="error" v-if="!airPackageModal.noOfPackageUnit">{{
                                packageErrorList.noOfPackageUnit }}</span>
                            </md-layout>

                            <!-- <md-layout md-flex="20" v-if="airPackageModal.shipperFreightId!=''">
                                <label>Total No. of Packages Added</label>

                                <b-form-input :formatter="capitalizeAll"
                                  id="cargoGrossWeight"
                                  name="cargoGrossWeight"
                                  type="number"
                                  v-model="totalPackage"
                                  @keyup="VolumeWeightBySysAmount"
                                  disabled
                                ></b-form-input>
                              </md-layout>-->
                          </md-layout>

                          <div class="row mt-3">
                            <div v-if="
                                airPackageModal.shipperFreightId != '' && showPakg == true
                              " class="col-md-12 grid-margin stretch-card">
                              <span class="error">Remaining Packages to be added =
                                {{ packagePending }}</span>
                              <div class="card">
                                <div class="card-body">
                                  <h4 class="card-title">Package Details</h4>
                                  <md-layout md-gutter class="gutr">
                                    <md-layout md-flex="100">
                                      <md-layout md-flex="100">
                                        <label>No. Of Packages</label>

                                        <b-form-input :formatter="capitalizeAll" id="noOfPackage" name="noOfPackage"
                                          v-model="airPackageModal.noOfPackage" @keyup="VolumeWeightCargoAmount"
                                          type="number"></b-form-input>
                                      </md-layout>

                                      <span class="error" v-if="!airPackageModal.noOfPackage">{{
                                        packageErrorList.noOfPackage }}</span>
                                    </md-layout>
                                  </md-layout>

                                  <md-layout md-gutter class="gutr">
                                    <md-layout md-flex="35">
                                      <md-layout md-flex="100">
                                        <label>Length</label>

                                        <b-form-input :formatter="capitalizeAll" id="packageLength" name="packageLength"
                                          v-model="airPackageModal.packageLength" @keyup="VolumeWeightCargoAmount"
                                          type="number"></b-form-input>
                                      </md-layout>

                                      <span class="error" v-if="!airPackageModal.packageLength">{{
                                        packageErrorList.packageLength }}</span>
                                    </md-layout>

                                    <md-layout md-flex="35">
                                      <md-layout md-flex="100">
                                        <label>Width</label>

                                        <b-form-input :formatter="capitalizeAll" id="packageWidth" name="packageWidth"
                                          v-model="airPackageModal.packageWidth" @keyup="VolumeWeightCargoAmount"
                                          type="number"></b-form-input>
                                      </md-layout>

                                      <span class="error" v-if="!airPackageModal.packageWidth">{{
                                        packageErrorList.packageWidth }}</span>
                                    </md-layout>

                                    <md-layout md-flex="30">
                                      <md-layout md-flex="100">
                                        <label>Height</label>

                                        <b-form-input :formatter="capitalizeAll" id="packageHeight" name="packageHeight"
                                          v-model="airPackageModal.packageHeight" @keyup="VolumeWeightCargoAmount"
                                          type="number"></b-form-input>
                                      </md-layout>

                                      <span class="error" v-if="!airPackageModal.packageHeight">{{
                                        packageErrorList.packageHeight }}</span>
                                    </md-layout>
                                  </md-layout>

                                  <md-layout md-gutter class="gutr">
                                    <md-layout md-flex="40">
                                      <label for="deliveryTerms1">Unit</label>

                                      <model-list-select :list="pkgwgtUnitList" v-model="airPackageModal.packageUnit"
                                        option-value="pkgwgtUnitVal" option-text="pkgwgtUnitText" placeholder="Select "
                                        @input="VolumeWeightCargoAmount"></model-list-select>

                                      <span class="error" v-if="!airPackageModal.packageUnit">{{
                                        packageErrorList.packageUnit }}</span>
                                    </md-layout>
                                    <md-layout md-flex="5"></md-layout>
                                    <md-layout md-flex="55">
                                      <md-layout md-flex="100">
                                        <label>Package Volume</label>

                                        <b-form-input :formatter="capitalizeAll" id="packageVolume" name="packageVolume"
                                          v-model="airPackageModal.packageVolume" disabled></b-form-input>
                                      </md-layout>
                                    </md-layout>
                                  </md-layout>

                                  <md-layout md-gutter class="gutr">
                                    <md-layout md-flex="10">
                                      <b-button variant="primary" size="sm" id="addButtonLoaderpackage"
                                        @click="addPackage">{{
                                        airPackageModal.cargoId != "" ? "Edit" : "Add"
                                        }}
                                        Package</b-button>

                                      <md-spinner md-indeterminate id="loaderpackage"
                                        style="display: none"></md-spinner>
                                    </md-layout>
                                  </md-layout>
                                </div>
                              </div>
                            </div>
                            <!-- && (airPackageModal.noOfPackageUnit==totalPackage) && isLoading==false" -->
                            <div v-if="
                                airPackageModal.shipperFreightId != '' &&
                                showCharge == true
                              " class="col-md-12 grid-margin stretch-card">
                              <div class="card">
                                <div class="card-body">
                                  <h4 class="card-title">Cargo Details</h4>
                                  <md-layout md-gutter class="gutr" v-if="airPackageModal.shipperFreightId != ''">
                                    <md-layout md-flex="25" v-if="airPackageModal.shipperFreightId != ''">
                                      <label>Package Type</label>
                                      <model-list-select :list="packageNameList" id="clientId"
                                        v-model="airPackageModal.packageIdUnit" option-value="packageId"
                                        option-text="packageName" placeholder="Select  Package "></model-list-select>

                                      <span class="error" v-if="!airPackageModal.packageIdUnit">{{
                                        packageErrorList.packageIdUnit }}</span>
                                    </md-layout>
                                    <md-layout md-flex="5"></md-layout>

                                    <md-layout md-flex="20">
                                      <md-layout md-flex="100">
                                        <label>Cargo Gross Weight</label>

                                        <b-form-input :formatter="capitalizeAll" id="cargoGrossWeight"
                                          name="cargoGrossWeight" type="number"
                                          v-model="airPackageModal.cargoGrossWeight"
                                          @keyup="VolumeWeightBySysAmount"></b-form-input>
                                      </md-layout>

                                      <!-- <span
                                          class="error"
                                          v-if="!airPackageModal.cargoGrossWeight"
                                        >{{packageErrorList.cargoGrossWeight}}</span>-->
                                    </md-layout>

                                    <md-layout md-flex="15">
                                      <label for="deliveryTerms">Unit</label>

                                      <model-list-select :list="CargowgtUnitList" v-model="airPackageModal.CargowgtUnit"
                                        option-value="CargowgtUnitVal" option-text="CargowgtUnitText"
                                        placeholder="Select"></model-list-select>

                                      <!-- <span
                                          class="error"
                                          v-if="!airPackageModal.CargowgtUnit"
                                        >{{packageErrorList.CargowgtUnit}}</span>-->
                                    </md-layout>
                                    <md-layout md-flex="5"></md-layout>
                                    <md-layout md-flex="30">
                                      <md-layout md-flex="100">
                                        <label>Chargeable Vol.Wgt By Airline</label>

                                        <b-form-input :formatter="capitalizeAll" id="chargeVolWgtAir"
                                          name="chargeVolWgtAir" v-model="airPackageModal.chargeVolWgtAir"
                                          @keyup="FinalVolumeWeightAmount" type="number"></b-form-input>
                                      </md-layout>

                                      <!-- <span
                                          class="error"
                                          v-if="!airPackageModal.chargeVolWgtAir"
                                        >{{packageErrorList.chargeVolWgtAir}}</span>-->
                                    </md-layout>
                                  </md-layout>

                                  <md-layout md-gutter class="gutr" v-if="
                                      airPackageModal.shipperFreightId != '' &&
                                      packageDetails.length > 0
                                    ">
                                    <md-layout md-flex="30">
                                      <md-layout md-flex="100">
                                        <label>Volume Weight of Cargo</label>

                                        <b-form-input :formatter="capitalizeAll" id="cargoVolumeWeight"
                                          name="cargoVolumeWeight" v-model="airPackageModal.cargoVolumeWeight"
                                          type="number" disabled></b-form-input>
                                      </md-layout>
                                    </md-layout>

                                    <md-layout md-flex="5"></md-layout>

                                    <md-layout md-flex="30">
                                      <md-layout md-flex="100">
                                        <label>Chargeable Vol.Wgt By System</label>

                                        <b-form-input :formatter="capitalizeAll" id="chargeVolWgtSys"
                                          name="chargeVolWgtSys" v-model="airPackageModal.chargeVolWgtSys"
                                          disabled></b-form-input>
                                      </md-layout>
                                    </md-layout>

                                    <md-layout md-flex="5"></md-layout>

                                    <md-layout md-flex="30">
                                      <md-layout md-flex="100">
                                        <label>Final Chargeable Weight</label>

                                        <b-form-input :formatter="capitalizeAll" id="finalChargableWeight"
                                          name="finalChargableWeight" v-model="airPackageModal.finalChargableWeight"
                                          disabled></b-form-input>
                                      </md-layout>
                                    </md-layout>
                                    <md-layout md-gutter class="gutr" v-if="
                                        airPackageModal.shipperFreightId != '' &&
                                        packageDetails.length > 0
                                      ">
                                      <md-layout md-flex="15">
                                        <b-button variant="info" size="sm" id="addButtonLoaderMultiple" v-if="
                                            airPackageModal.shipperFreightId != '' &&
                                            packageDetails.length > 0
                                          " @click="updateCargo">Update</b-button>

                                        <md-spinner md-indeterminate id="loaderMultiple"
                                          style="display: none"></md-spinner>
                                      </md-layout>
                                    </md-layout>
                                  </md-layout>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- <md-layout
                              md-gutter
                              v-if="packageDetails.length>0 && airPackageModal.shipperFreightId!=''"
                            >
                              <md-layout md-flex="70"></md-layout>

                              <md-layout md-flex="30">
                                <h4
                                  class="showMoreData"
                                  @click="showMoreContainer"
                                >Click here to {{showPackage==true?"Hide":"Add"}} Package Details</h4>
                              </md-layout>
                            </md-layout>-->
                          <div class="gutr">
                            <b-button variant="outline-danger" class="pull-right" @click="closeMerge">Close</b-button>
                            <b-button v-if="
                                airPackageModal.shipperFreightId != '' &&
                                packagePending != '0'
                              " variant="outline-success" class="pull-right mr-2" @click="addMorePKG">Add
                              More</b-button>
                          </div>
                        </b-card-text>
                      </b-card>
                    </div>
                  </b-modal>
                </div>

                <h5 class="mt-3">
                  <b-badge>Airline Charges</b-badge>
                </h5>

                <md-layout md-gutter>
                  <md-layout md-flex="50">
                    <label for="sourceOriginclientId">Client Name</label>

                    <model-list-select :list="packageClientList" id="clientNamenew"
                      v-model="airPackageModal.shipperFreightId" option-value="shipperFreightId"
                      option-text="clientName" placeholder="Select Client Name"
                      :isDisabled="airPackageModal.cargoId != '' ? true : false"></model-list-select>

                    <span class="error" v-if="!airPackageModal.shipperFreightId">{{
                      packageErrorList.shipperFreightId
                      }}</span>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="40" v-if="airPackageModal.shipperFreightId != ''">
                    <label>Total Packages of Client</label>

                    <b-form-input :formatter="capitalizeAll" :disabled="
                        AirFreightMain.airFFType == 'fclConsolidation' ? false : true
                      " id="noOfPackageUnit" name="noOfPackageUnit" type="number"
                      v-model="airPackageModal.noOfPackageUnit"></b-form-input>
                    <span class="error" v-if="!airPackageModal.noOfPackageUnit">{{
                      packageErrorList.noOfPackageUnit
                      }}</span>
                  </md-layout>

                  <!-- <md-layout md-flex="20" v-if="airPackageModal.shipperFreightId!=''">
                                <label>Total No. of Packages Added</label>

                                <b-form-input :formatter="capitalizeAll"
                                  id="cargoGrossWeight"
                                  name="cargoGrossWeight"
                                  type="number"
                                  v-model="totalPackage"
                                  @keyup="VolumeWeightBySysAmount"
                                  disabled
                                ></b-form-input>
                        </md-layout>-->
                </md-layout>

                <div class="row mt-3">
                  <!-- && (airPackageModal.noOfPackageUnit==totalPackage) && isLoading==false" -->
                  <div v-if="airPackageModal.shipperFreightId != ''" class="col-md-12 grid-margin stretch-card">
                    <md-layout md-gutter v-if="airPackageModal.shipperFreightId != ''">
                      <md-layout md-flex="25" v-if="airPackageModal.shipperFreightId != ''">
                        <label>Package Type</label>
                        <model-list-select :list="packageNameList" id="clientId" v-model="airPackageModal.packageIdUnit"
                          option-value="packageId" option-text="packageName"
                          placeholder="Select  Package "></model-list-select>

                        <span class="error" v-if="!airPackageModal.packageIdUnit">{{
                          packageErrorList.packageIdUnit
                          }}</span>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="20">
                        <md-layout md-flex="100">
                          <label>Cargo Gross Weight</label>

                          <b-form-input :formatter="capitalizeAll" id="cargoGrossWeight" name="cargoGrossWeight"
                            type="number" v-model="airPackageModal.cargoGrossWeight"
                            @keyup="VolumeWeightBySysAmount"></b-form-input>
                        </md-layout>

                        <!-- <span
                                          class="error"
                                          v-if="!airPackageModal.cargoGrossWeight"
                              >{{packageErrorList.cargoGrossWeight}}</span>-->
                      </md-layout>

                      <md-layout md-flex="15">
                        <label for="deliveryTerms">Unit</label>

                        <model-list-select :list="CargowgtUnitList" v-model="airPackageModal.CargowgtUnit"
                          option-value="CargowgtUnitVal" option-text="CargowgtUnitText"
                          placeholder="Select"></model-list-select>

                        <!-- <span
                                          class="error"
                                          v-if="!airPackageModal.CargowgtUnit"
                              >{{packageErrorList.CargowgtUnit}}</span>-->
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label>Volume Weight of Cargo</label>

                          <b-form-input :formatter="capitalizeAll" id="cargoVolumeWeight" name="cargoVolumeWeight"
                            v-model="airPackageModal.cargoVolumeWeight" type="number" disabled></b-form-input>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="gutr" v-if="
                        airPackageModal.shipperFreightId != '' &&
                        packageDetails.length > 0
                      ">
                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label>Chargeable Vol.Wgt By Airline</label>

                          <b-form-input :formatter="capitalizeAll" id="chargeVolWgtAir" name="chargeVolWgtAir"
                            v-model="airPackageModal.chargeVolWgtAir" @keyup="FinalVolumeWeightAmount"
                            type="number"></b-form-input>
                        </md-layout>

                        <!-- <span
                                          class="error"
                                          v-if="!airPackageModal.chargeVolWgtAir"
                              >{{packageErrorList.chargeVolWgtAir}}</span>-->
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label>Chargeable Vol.Wgt By System</label>

                          <b-form-input :formatter="capitalizeAll" id="chargeVolWgtSys" name="chargeVolWgtSys"
                            v-model="airPackageModal.chargeVolWgtSys" disabled></b-form-input>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label>Final Chargeable Weight</label>

                          <b-form-input :formatter="capitalizeAll" id="finalChargableWeight" name="finalChargableWeight"
                            v-model="airPackageModal.finalChargableWeight" disabled></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="gutr" v-if="
                          airPackageModal.shipperFreightId != '' &&
                          packageDetails.length > 0
                        ">
                        <md-layout md-flex="15">
                          <b-button variant="info" size="sm" id="addButtonLoaderMultiple" v-if="
                              airPackageModal.shipperFreightId != '' &&
                              packageDetails.length > 0
                            " @click="updateCargo">Update</b-button>

                          <md-spinner md-indeterminate id="loaderMultiple" style="display: none"></md-spinner>
                        </md-layout>
                      </md-layout>
                    </md-layout>
                  </div>
                </div>

                <!-- <md-layout
                              md-gutter
                              v-if="packageDetails.length>0 && airPackageModal.shipperFreightId!=''"
                            >
                              <md-layout md-flex="70"></md-layout>

                              <md-layout md-flex="30">
                                <h4
                                  class="showMoreData"
                                  @click="showMoreContainer"
                                >Click here to {{showPackage==true?"Hide":"Add"}} Package Details</h4>
                              </md-layout>
                      </md-layout>-->

                <md-layout md-gutter class="gutr" v-if="AtleastOnePackage.length > 0">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="50">
                    <label class="error" style="padding: 0; margin: 0">
                      <u>Note:</u>
                      Select aleast one package details for
                      {{ AtleastOnePackage.join(", ") }}
                    </label>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter v-if="PackageNotMatch.length > 0">
                  <md-layout md-flex="100">
                    <label class="error">
                      <u>Note:</u>
                      Total package is not equal to no of packages for
                      {{ PackageNotMatch.join(", ") }}
                    </label>
                  </md-layout>
                </md-layout>
              </b-card>
              <md-layout md-gutter class="gutr" v-if="openShipper != true && packageDetails.length > 0">
                <md-layout md-flex="40">
                  <b-button class="mt-3" variant="primary" id="addButtonLoaderpro" @click="proceedBooking">Save &
                    Proceed To Booking Order</b-button>

                  <md-spinner md-indeterminate id="loaderpro" style="display: none"></md-spinner>
                </md-layout>
              </md-layout>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div>
      <b-modal ref="my-modal" hide-footer title="">
        <div class="d-block text-center">
          <h3>
            Package Confirmation
            <br />
          </h3>
          <p class="my-4">
            This Assignment has {{ airPackageModal.noOfPackageUnit }} Packages
          </p>
        </div>
        <b-button class="mt-3" variant="outline-success" block @click="yesModal">Yes</b-button>
        <b-button class="mt-2" variant="outline-danger" block @click="noModal">No</b-button>
      </b-modal>
    </div>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopError"></md-dialog-alert>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"
      @close="goToBookingPage"></md-dialog-alert>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop1"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onClose6"
      ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    if (globalPermissionStatus("Air Freight")) {
      this.$store.dispatch("setCurrentRoute", "/airFreight/airFFExportConsol");
      this.getData();
      this.getServicesData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  watch: {
    airFreightModal: {
      handler: function (newVal, oldVal) {
        if (newVal.commodityId != "") {
          let arrayFilter = this.getCommodityData.filter((x) => {
            return x.commodityId == newVal.commodityId;
          })[0];

          this.CommodityCallback(arrayFilter);
        }

        if (this.airFreightModal.clientId != "") {
          let checkAlready = this.consoMultipleShipperTable.filter((x) => {
            return x.clientId == this.airFreightModal.clientId;
          });

          if (checkAlready.length > 0 && this.airFreightModal.shipperFreightId == "") {
            this.alert.content = checkAlready[0].clientName + " Already Exist";
            this.$refs["addPopError"].open();
            this.airFreightModal.clientId = "";
          } else {
            let arrayClentId = this.getCLientData.filter((x) => {
              return x.clientId == this.airFreightModal.clientId;
            });

            if (arrayClentId.length > 0) {
              this.airFreightModal.clientName = arrayClentId[0].clientName;
            }
          }
        }
      },
      deep: true,
    },
    airPackageModal: {
      handler: function (newVal, oldVal) {
        this.allFinalWeight();
      },

      deep: true,
    },
  },

  data() {
    return {
      airLineList: [],
      isLoading: false,

      transportTypeList: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],

      departureAirportListName: [],

      stuffingTypeList: [
        {
          stuffingTypeVal: "airport",
          stuffingTypeText: "Airport",
        },
        {
          stuffingTypeVal: "warehouse",
          stuffingTypeText: "Warehouse",
        },
        {
          stuffingTypeVal: "pickup",
          stuffingTypeText: "Pickup",
        },
      ],

      cctypeList: [
        {
          ccTypeVal: "Own",
          ccTypeTxt: "Own",
        },
        {
          ccTypeVal: "Outsourced",
          ccTypeTxt: "Outsourced",
        },
      ],

      shipmentExectionList: [
        {
          shipmentExectionVal: "AirFreight",
          shipmentExectionTxt: "Air Freight",
        },
        {
          shipmentExectionVal: "Courier",
          shipmentExectionTxt: "Courier",
        },
      ],

      containerInfoList: [
        {
          containerInfoVal: "fclNormal",
          containerInfoText: "FCL Normal",
        },
        {
          containerInfoVal: "fclConsolidation",
          containerInfoText: "FCL Consolidation",
        },
      ],

      deliveryModeList: [
        {
          deliveryModeVal: "upto_AirPort",
          deliveryModeText: "Upto AirPort",
        },
        {
          deliveryModeVal: "Door",
          deliveryModeText: "Door",
        },
        {
          deliveryModeVal: "fpod",
          deliveryModeText: "FPOD",
        }
      ],

      CargowgtUnitList: [
        {
          CargowgtUnitVal: "Kg",
          CargowgtUnitText: "Kg",
        },
        {
          CargowgtUnitVal: "LBS",
          CargowgtUnitText: "LBS",
        },
      ],

      pkgwgtUnitList: [
        {
          pkgwgtUnitVal: "Cm",
          pkgwgtUnitText: "Cm",
        },
        {
          pkgwgtUnitVal: "Inch",
          pkgwgtUnitText: "Inch",
        },
      ],

      deliveryTermsList: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "Ex-Works",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "FOB_POR",
          deliveryTermsText: "FOB_POR_",
        },
        {
          deliveryTermsVal: "FOB_LoadPort",
          deliveryTermsText: "FOB_LoadPort_",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
        {
          deliveryTermsVal: "FAS",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "CIP",
          deliveryTermsText: "CIP",
        },
        {
          deliveryTermsVal: "CPT",
          deliveryTermsText: "CPT",
        },
        {
          deliveryTermsVal: "DAF",
          deliveryTermsText: "DAF",
        },
        {
          deliveryTermsVal: "DES",
          deliveryTermsText: "DES",
        },
        {
          deliveryTermsVal: "DEQ",
          deliveryTermsText: "DEQ",
        },
      ],

      shipmentTypeList: [
        {
          shipmentTypeVal: "Sea_Shipment",
          shipmentTypeText: "Sea Shipment",
        },
        {
          shipmentTypeVal: "Air_Shipment",
          shipmentTypeText: "Air Shipment",
        },
      ],

      pdaDetailsName: [
        {
          pdaDetailsVal: "Pridel",
          pdaDetailsText: "Pridel",
        },
        {
          pdaDetailsVal: "Shipper",
          pdaDetailsText: "Shipper",
        },
        {
          pdaDetailsVal: "Liner",
          pdaDetailsText: "Liner",
        },
      ],

      oceanFreightTermsName: [
        {
          oceanFreightTermsVal: "prepaid",
          oceanFreightTermsText: "Prepaid",
        },
        {
          oceanFreightTermsVal: "collect",
          oceanFreightTermsText: "Collect",
        },
      ],

      prepaidDetailsName: [
        {
          prepaidDetailsVal: "C_F",
          prepaidDetailsText: "C & F",
        },
        {
          prepaidDetailsVal: "CIF",
          prepaidDetailsText: "CIF",
        },
      ],

      collectDetailsName: [
        {
          collectDetailsVal: "Ex_Works",
          collectDetailsText: "Ex Works",
        },
        {
          collectDetailsVal: "FOB_Place_Of_Receipt",
          collectDetailsText: "FOB Place Of Receipt",
        },
        {
          collectDetailsVal: "FOB_Load_Port",
          collectDetailsText: "FOB Load Port",
        },
      ],

      showAdd: false,

      bookingSourceList: [
        {
          bookingSourceVal: "Origin",
          bookingSourceText: "Origin",
        },
        {
          bookingSourceVal: "Destination",
          bookingSourceText: "Destination",
        },
      ],

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",

        ok: "ok",
      },

      allAgentColoader: [],
      packageDetails: [],
      consoMultipleShipperTable: [],
      allShipperData: [],
      PortDestiList: [],
      PortDischargeList: [],
      finalAllPlaceData: [],

      CommodityAll: {},
      autoClientName: {},
      showPackageSection: "",
      totalPackage: "",
      packagePending: "",
      totalPackageVolume: "",

      divideCm: "6000",
      divideCmCourier: "5000",

      divideInch: "366",
      divideInchCourier: "305",

      AirFreightMain: {
        allModuleId: "",
        airlineId: "",
        airFcExportId: "",
        airFFExportSeries: "",
        cargoId: "",
        shipperFreightId: "",
        jobType: [],
        shipmentType: "Air_Shipment",
        transportType: "Export",
        airportDeparture: "",
        airportDestination: "",
        shipmentExecution: "",
        airFFType: "",
        multipleShipper: "",
        multipleCargo: "",
        statusFinalExp: "",
      },

      airFreightModal: {
        airFcExportId: "",
        cargoId: "",
        shipperFreightId: "",
        clientId: "",
        clientName: "",
        cargoReceivedAt: "",
        pickup_location: "",
        pickup_location_err: "",
        bookingSource: "",
        agentName: "",
        sourceOriginclientId: "",
        buyer: "",
        buyingHouse: "",
        otherSpecify: "",
        ccType: "",
        ccCha: "",
        deliveryMode: "",
        fpod_location: "",
        fpod_location_err: "",
        doorFpod: "",
        deliveryTerms: "",
        commodityId: "",
        commodityType: "",
        itemDescription: "",
        IMDGClass: "",
        UNNumber: "",
        packingCode: "",
        temperatureRequired: "",
        otherComodity: "",
        specificAdditionalTask: "",
        otherServices: [],
        additionalMoreTask: [],
        typeAirway: "",
        HAWBTerms: "",
        MAWBTerms: "",
        freightTerms: "",
        door_add:"",
      },

      AtleastOnePackage: [],
      PackageNotMatch: [],
      HAWBTermsError: "",
      MAWBTermsError: "",
      freightTermsError: "",
      AirwayType: [
        {
          value: "HouseAirwayBL",
          text: "House Airway B/L",
        },
        {
          value: "DirectAirwayBL",
          text: "Direct Airway B/L",
        },
      ],

      freightTerms: [
        {
          value: "Prepaid",
          text: "Prepaid",
        },
        {
          value: "Collect",
          text: "Collect",
        },
      ],
      packageNameList: [],

      airPackageModal: {
        airFcExportId: "",
        cargoId: "",
        cargoVolumeWeight: "",
        chargeVolWgtSys: "",
        chargeVolWgtAir: "0",
        finalChargableWeight: "",
        cargoGrossWeight: "",
        CargowgtUnit: "Kg",
        clientId: "",
        shipperFreightId: "",
        airFcExportId: "",
        clientName: "",
        noOfPackage: "",
        packageLength: "",
        packageWidth: "",
        packageHeight: "",
        packageUnit: "Cm",
        packageVolume: "",
        noOfPackageUnit: "",
        packageIdUnit: "",
      },

      showCharge: false,
      showPakg: false,
      deleteId: "",
      shippingIdError: "",
      totalContainer: "",
      noOfContainerError: "",
      containerTypeIdError: "",
      fobReceiptName: "",
      fobLoadPortName: "",
      commodityArray: [],
      getPortData: ["Agra"],
      showPackage: false,
      openShipper: false,

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: "",
      },

      getCLientData: ["gfdg"],
      getagentName: ["gfdg"],
      showSegmentArray: [],
      showOtherServiceArray: [],
      showAdditionalMoreTaskArray: [],
      packageDetailsTemp: [],
      driverNameDetail: ["iji"],

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",

        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New",
      },

      errorAtleastOne: "",

      ffExportError: [
        "Please Select Client Name",
        "Please Select Place of Receipt",
        "Please Select Load  Port Name",
        "Please Select Port  of Discharge",
        "Please Select final Delievery",
        "Please Select Commidity",
        "Please Select Stuffing type",
      ],

      ffExporterrorList: {
        clientId: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        commodityId: "",
        stuffingType: "",
      },

      mainErrorList: {
        airportDeparture: "",
        airportDestination: "",
        airFFType: "",
        shipmentExecution: "",
      },
      mainError: [
        "Select Departure Airport",
        "Select Arrival Airport",
        "Select FF Activity Type",
        "Select Shipment Execution",
      ],

      shipperErrorList: {
        clientId: "",
        cargoReceivedAt: "",
        typeAirway: "",
        bookingSource: "",
        deliveryMode: "",
        commodityId: "",
        // pickup_location: "",
        // fpod_location: "",
      },

      shipperError: [
        "Select Client Name",
        "Select Cargo Received Place",
        "Select Type Airway",
        "Select Booking Source",
        "Select Destination Delivery Mode",
        "Select Commidity",
        // "Enter Pickup Location",
        // "Enter FPOD Location",
      ],

      packageError: [
        "Select Client Name",
        // "Enter Cargo Gross Weight",
        // "Select Weight Unit",
        // "Enter Volume Weight By Airline",
        "Enter No. of Package",
        "Enter Package Length",
        "Enter Package width",
        "Enter Package height",
        "Select Unit",
        "Enter No. of Package",
        "Select Package Name",
      ],

      packageErrorList: {
        shipperFreightId: "",
        // cargoGrossWeight: "",
        // CargowgtUnit: "",
        // chargeVolWgtAir: "",
        noOfPackage: "",
        packageLength: "",
        packageWidth: "",
        packageHeight: "",
        packageUnit: "",
        noOfPackageUnit: "",
        packageIdUnit: "",
      },
      enablePackageEdit: false,
      getPortDischargeList: [],

      shipmentTypeName: [
        {
          shipmentTypeVal: "Sea_Shipment",
          shipmentTypeText: "Sea Shipment",
        },
        {
          shipmentTypeVal: "Air_Shipment",
          shipmentTypeText: "Air Shipment",
        },
      ],

      jobTypeSelectVal: false,
      otherServicesVal: false,

      getShippingLineData: ["zim"],
      getCommodityData: ["zim"],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: ["agra"],
      IcdPOrtList: ["agra"],

      validate: true,

      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      ExecutionDisable: "",
      oldValue: "",

      AIR_TRACK: "",
      AIR_EXEC: "",
      AIR_BOOK: "",

      counter: 0,
    };
  },

  mounted() {
    // this.$refs["my-modal"].show();
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    BannerComponent,
    CustomLoader,
  },

  computed: {
    commodityList() {
      return this.getCommodityData;
    },

    allLocationList() {
      return this.getAlllocationListData;
    },

    agentNameList() {
      return this.getagentName.filter((x) => {
        return x.categoryType == "Agent";
      });
    },
    chaNameList() {
      return this.getagentName.filter((x) => {
        return x.categoryType == "CHA";
      });
    },

    clientList() {
      return this.getCLientData;
    },

    packageClientList() {
      return this.consoMultipleShipperTable;
    },

    departureAirportList() {
      return this.departureAirportListName;
    },
  },

  methods: {
    yesModal() {
      this.enablePackageEdit = false;
    },
    noModal() {
      this.enablePackageEdit = true;
    },
    gotToPage(ID) {
      if (ID == "BOOK") {
        this.$router.push({
          path: "/airfreight/airFreightBooking",
        });
      } else if (ID == "EXEC") {
        this.$router.push({
          path: "/airfreight/airFreightExecution",
        });
      } else if (ID == "TRACK") {
        this.$router.push({
          path: "/airfreight/airTrackingFFExport",
        });
      } else {
        console.log("no");
      }
    },
    addPackModal(ID) {
      if (ID == "1") {
        this.showPakg = true;
      } else {
        this.showCharge = true;
      }
      // Object.keys(this.airPackageModal).map(x => {
      //   this.airPackageModal[x] = "";
      // });
      this.$refs["packagePop"].show();
    },
    addMorePKG() {
      this.airPackageModal.cargoId = "";
      this.airPackageModal.noOfPackage = "";
      this.airPackageModal.packageLength = "";
      this.airPackageModal.packageWidth = "";
      this.airPackageModal.packageHeight = "";
      this.airPackageModal.packageVolume = "";
    },
    closeMerge() {
      this.airPackageModal.cargoId = "";
      // this.airPackageModal.shipperFreightId = "";
      this.airPackageModal.noOfPackage = "";
      this.airPackageModal.packageLength = "";
      this.airPackageModal.packageWidth = "";
      this.airPackageModal.packageHeight = "";
      this.airPackageModal.packageVolume = "";

      // Object.keys(this.airPackageModal).map(x => {
      //   this.airPackageModal[x] = "";
      // });
      this.$refs["packagePop"].hide();
      this.showCharge = false;
      this.showPakg = false;
    },
    addStatus() {
      let data = {
        jobType: "1",
        typeOf: "4",
        allMessageId: this.$sessionsStorage.get("editffAirExport"),
        statusMain: this.AirFreightMain.statusFinalExp,
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));

      this.$router.push({
        path: "/UpdateStatus/internalAssignStatus",
      });
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    showMoreShipper() {
      if (this.openShipper == false) {
        this.openShipper = true;
      } else {
        this.openShipper = false;
      }
    },

    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "air_cargo_detail",
          tableId: "cargoId",
          isActive: "isActiveCargo",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            this.getData();
            this.deleteId = "";
          })
          .catch((error) => {});
      }
    },
    previousPoView() {
      this.$router.push({
        path: "/airFreight/viewAirFF",
      });
    },

    allFinalWeight() {
      if (this.airPackageModal.shipperFreightId != "") {
        if (this.oldValue == "") {
          this.oldValue = this.airPackageModal.shipperFreightId;
        } else if (this.oldValue == this.airPackageModal.shipperFreightId) {
        } else {
          this.counter = 0;

          this.oldValue = this.airPackageModal.shipperFreightId;
        }

        let arrayID = this.consoMultipleShipperTable.filter((x) => {
          return x.shipperFreightId == this.airPackageModal.shipperFreightId;
        });

        if (arrayID.length > 0) {
          this.airPackageModal.airFcExportId = arrayID[0].airFcExportId;

          this.airPackageModal.clientId = arrayID[0].clientId;

          this.airPackageModal.clientName = arrayID[0].clientName;
        }

        let arrayNew = this.packageDetailsTemp;

        if (arrayNew.length > 0) {
          let arrayMain = arrayNew.filter((x) => {
            return x.shipperFreightId == this.airPackageModal.shipperFreightId;
          });

          if (arrayMain.length > 0) {
            this.totalPackage = 0;

            this.totalPackageVolume = 0;

            arrayMain.map((x, index) => {
              this.totalPackage =
                parseFloat(x.noOfPackage) + parseFloat(this.totalPackage);

              this.totalPackageVolume =
                parseFloat(x.packageVolume) + parseFloat(this.totalPackageVolume);

              this.airFreightModal.cargoVolumeWeight = this.totalPackageVolume;
            });

            this.packageDetails = arrayMain;

            if (this.counter == 0) {
              this.airPackageModal.cargoGrossWeight = arrayID[0].cargoGrossWeight;

              this.airPackageModal.CargowgtUnit = arrayID[0].CargowgtUnit;

              this.airPackageModal.chargeVolWgtSys = arrayID[0].chargeVolWgtSys;

              this.airPackageModal.chargeVolWgtAir = arrayID[0].chargeVolWgtAir;
              this.airPackageModal.noOfPackageUnit = arrayID[0].noOfPackageUnit;
              this.airPackageModal.packageIdUnit = arrayID[0].packageIdUnit;

              this.airPackageModal.finalChargableWeight = arrayID[0].finalChargableWeight;

              this.airPackageModal.cargoVolumeWeight = arrayID[0].cargoVolumeWeight;

              this.counter++;
            }
          } else {
            if (this.counter == 0) {
              this.airPackageModal.cargoGrossWeight = "";

              this.airPackageModal.cargoVolumeWeight = "";

              this.airPackageModal.chargeVolWgtAir = "0";

              this.airPackageModal.chargeVolWgtSys = "";
              this.airPackageModal.finalChargableWeight = "";
              this.counter++;
            }

            this.packageDetails = [];
            this.totalPackage = 0;
          }
        } else {
          this.totalPackage = 0;
          this.packageDetails = arrayNew;
        }
      } else {
        this.totalPackage = 0;
        this.packageDetails = this.packageDetailsTemp;
      }

      this.packagePending =
        parseInt(this.airPackageModal.noOfPackageUnit) - parseInt(this.totalPackage);
    },

    showMoreContainer() {
      if (this.showPackage == false) {
        this.showPackage = true;
      } else {
        this.showPackage = false;
      }
    },

    VolumeWeightBySysAmount() {},

    FinalVolumeWeightAmount() {},

    VolumeWeightCargoAmount() {
      let newVal = "";
      if (this.AirFreightMain.shipmentExecution == "Courier") {
        newVal =
          this.airPackageModal.packageUnit == "Cm"
            ? this.divideCmCourier
            : this.divideInchCourier;
      } else {
        newVal =
          this.airPackageModal.packageUnit == "Cm" ? this.divideCm : this.divideInch;
      }

      let mainVolume =
        (parseFloat(this.airPackageModal.packageLength) *
          parseFloat(this.airPackageModal.packageWidth) *
          parseFloat(this.airPackageModal.packageHeight) *
          parseFloat(this.airPackageModal.noOfPackage)) /
        parseFloat(newVal);

      this.airPackageModal.packageVolume = mainVolume.toFixed(3);
    },

    viewEditShiper(item1) {
      window.scroll(0, 10);

      let arrayOther = [];

      let arrayAdditional = [];

      let arrayFilterShiper = this.consoMultipleShipperTable.filter((x) => {
        return x.shipperFreightId == item1.shipperFreightId;
      });

      Object.keys(this.airFreightModal).map((x) => {
        this.airFreightModal[x] = arrayFilterShiper[0][x] || "";

        if (x == "otherServices") {
          arrayOther = arrayFilterShiper[0][x].split(",");
        }

        if (x == "additionalMoreTask") {
          arrayAdditional = arrayFilterShiper[0][x].split(",");
        }
      });

      this.airFreightModal["otherServices"] = [];

      this.airFreightModal["additionalMoreTask"] = [];

      this.showOtherServiceArray.map((x, index) => {
        let i = arrayOther.indexOf(x.value);

        i >= 0
          ? (this.airFreightModal.otherServices[index] = true)
          : (this.airFreightModal.otherServices[index] = false);
      });

      this.showAdditionalMoreTaskArray.map((x, index) => {
        let iA = arrayAdditional.indexOf(x.value);

        iA >= 0 ? this.airFreightModal.additionalMoreTask.push(x) : "";
      });
      this.airFreightModal.noOfPackageUnit = item1.noOfPackageUnit;
      this.getData();
    },

    viewEditPackage(item1) {
      this.showPakg = true;

      this.showCharge = false;

      this.showPackage = true;

      this.counter = 0;

      Object.keys(this.airPackageModal).map((x) => {
        this.airPackageModal[x] = item1[x] || "";
      });
      this.$refs["packagePop"].show();
    },

    jobTypeSelect(value, index) {
      if (value == "All") {
        if (this.jobTypeSelectVal == false) {
          this.AirFreightMain.jobType = Array(this.showSegmentArray.length).fill(true);

          this.jobTypeSelectVal = true;
        } else {
          this.AirFreightMain.jobType = Array(this.showSegmentArray.length).fill(false);

          this.jobTypeSelectVal = false;
        }
      }
    },

    otherServiceNameArraySelect(value, index) {
      if (value == "None") {
        if (this.otherServicesVal == false) {
          this.airFreightModal.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);

          this.otherServicesVal = true;
        } else {
          this.airFreightModal.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);

          this.otherServicesVal = false;
        }
        this.getServicesData();
      }
      if (value == "OthersSpecify") {
        this.showAdd = true;
      } else {
        this.showAdd = false;
      }
    },

    validatePackage() {
      let validate_new = true;

      Object.keys(this.packageErrorList).map((x, index) => {
        if (this.airPackageModal[x] == "") {
          this.packageErrorList[x] = this.packageError[index];

          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    validateShipper() {
      let validate_new = true;

      Object.keys(this.shipperErrorList).map((x, index) => {
        if (this.airFreightModal[x] == "") {
          // alert("1" + x);
          this.shipperErrorList[x] = this.shipperError[index];

          validate_new = false;
        }
      });

      
      if (this.airFreightModal.pickup_location == "" && this.airFreightModal.cargoReceivedAt === 'pickup') {
        this.airFreightModal.pickup_location_err = "Enter Pickup Location";
        validate_new = false;
      } else {
        this.airFreightModal.pickup_location_err = "";
      }

      if (this.airFreightModal.fpod_location == "" && this.airFreightModal.deliveryMode === 'fpod') {
        this.airFreightModal.fpod_location_err = "Enter FPOD Location";
        validate_new = false;
      } else {
        this.airFreightModal.fpod_location_err = "";
      }

      if (
        this.airFreightModal.HAWBTerms == "" &&
        this.airFreightModal.typeAirway == "HouseAirwayBL"
      ) {
        //alert("2");
        this.HAWBTermsError = "Select HAWB Terms";
        validate_new = false;
      } else {
        this.HAWBTermsError = "";
      }

      if (
        this.airFreightModal.MAWBTerms == "" &&
        this.airFreightModal.typeAirway == "HouseAirwayBL"
      ) {
        //alert("3");
        this.MAWBTermsError = "Select HAWB Terms";
        validate_new = false;
      } else {
        this.MAWBTermsError = "";
      }

      if (
        this.airFreightModal.freightTerms == "" &&
        this.airFreightModal.typeAirway == "DirectAirwayBL"
      ) {
        //alert("4");
        this.freightTermsError = "Select HAWB Terms";
        validate_new = false;
      } else {
        this.freightTermsError = "";
      }
      Object.keys(this.mainErrorList).map((x, index) => {
        if (this.AirFreightMain[x] == "") {
          //alert("5" + x);
          this.mainErrorList[x] = this.mainError[index];

          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    addMainWithShipper() {
      let newVal = [];
      let newValOther = [];
      let newAdditionalTask = [];

      this.showSegmentArray.map((x, index) => {
        if (this.AirFreightMain.jobType[index] == true) {
          newVal.push(x.value);
        }
      });

      this.showOtherServiceArray.map((x, index) => {
        if (this.airFreightModal.otherServices[index] == true) {
          newValOther.push(x.value);
        }
      });

      if (this.airFreightModal.additionalMoreTask.length > 0) {
        this.airFreightModal.additionalMoreTask.map((x, index) => {
          newAdditionalTask.push(x.value);
        });
      }

      this.AirFreightMain["jobType"] = newVal;
      this.airFreightModal["otherServices"] = newValOther;
      this.airFreightModal["additionalMoreTask"] = newAdditionalTask;

      let newData = {
        FCLAIRMAIN: this.AirFreightMain,
        FCLAIRShipper: this.airFreightModal,
        onlyExecMain: "fdsgdsgf",
      };

      this.validateShipper();

      if (this.validate != false) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirExport/addAirShipperAndMain.php`,
          data: JSON.stringify(newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {

              if (this.AirFreightMain.airFcExportId == "") {
                this.$sessionsStorage.set(
                  "editffAirExport",
                  data.airFcExportId
                );
                this.AirFreightMain.airFcExportId = data.airFcExportId;
              }

              if (this.AirFreightMain.airFFType == "fclNormal") {
                this.airFreightModal.shipperFreightId = data.shipperFreightId;
                this.airFreightModal.pickup_location = data.pickup_location;
                this.airFreightModal.fpod_location = data.fpod_location;
              }

              Object.keys(this.airFreightModal).map((x) => {
                if (x == "otherServices" || x == "additionalMoreTask") {
                  this.airFreightModal[x] = [];
                } else {
                  this.airFreightModal[x] = "";
                }
              });

              this.getData();
              this.openShipper = false;
            }
          })
          .catch((error) => {});
      }
    },

    DeleteList(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    addPackage() {
      this.validatePackage();
      if (this.validate != false) {
        $("#addButtonLoaderpackage").css("display", "none");

        $("#loaderpackage").css("display", "block");

        let options = {
          method: "POST",

          url: `${URL_BASE}/Api_AirExport/addPackageAirFF.php`,

          data: JSON.stringify(this.airPackageModal),

          crossDomain: true,

          headers: {
            Accept: "application/json",

            "Content-Type": "application/json",

            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const {
              statusText,

              status,

              data,
            } = result;

            if (status == 200 && data) {
              $("#loaderpackage").css("display", "none");

              $("#addButtonLoaderpackage").css("display", "block");

              // Object.keys(this.airPackageModal).map(x => {
              //   this.airPackageModal[x] = "";
              // });

              this.getData();
              this.oldValue = "";
              this.counter = 0;
              setTimeout(() => {
                this.validatePackageAtleast();
              }, 1000);

              this.showPackage = false;
            }
          })

          .catch((error) => {});
      }
    },

    validatePackageAtleast() {
      let arrayLengthZero = [];
      let arrayNotEqualPackage = [];

      this.consoMultipleShipperTable.map((x) => {
        let arrayCheck = this.packageDetails.filter((y) => {
          return y.shipperFreightId == x.shipperFreightId;
        });

        let totalPackagebyShipper = 0;

        arrayCheck.map((z) => {
          totalPackagebyShipper = +totalPackagebyShipper + +z.noOfPackage;
        });

        if (arrayCheck.length > 0) {
          if (x.noOfPackageUnit == totalPackagebyShipper) {
          } else {
            arrayNotEqualPackage.push(x.clientName);
          }
        } else {
          arrayLengthZero.push(x.clientName);
        }
      });

      if (arrayLengthZero.length > 0) {
        this.AtleastOnePackage = arrayLengthZero;
        return false;
      } else {
        this.AtleastOnePackage = [];
      }

      if (arrayNotEqualPackage.length > 0) {
        this.PackageNotMatch = arrayNotEqualPackage;
        return false;
      } else {
        this.PackageNotMatch = [];
        return true;
      }
    },

    proceedBooking() {
      let newVal = [];

      if (this.validatePackageAtleast()) {
        this.showSegmentArray.map((x, index) => {
          if (this.AirFreightMain.jobType[index] == true) {
            newVal.push(x.value);
          }
        });

        this.AirFreightMain["jobType"] = newVal;

        if (this.validate != false) {
          $("#addButtonLoaderpro").css("display", "none");

          $("#loaderpro").css("display", "block");

          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_AirExport/updateMainFFDetails.php`,
            data: JSON.stringify(this.AirFreightMain),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;

              if (status == 200 && data) {
                this.$sessionsStorage.set("editAirBookingId", data.airBookingId);
                $("#loaderpro").css("display", "none");
                $("#addButtonLoaderpro").css("display", "block");

                if (data.msg == "Inserted Successfully") {
                  this.alert.content = "Data Added Successfully";
                } else {
                  this.alert.content = "Data Updated Successfully";
                  this.$refs["addPop"].open();
                }
                this.getData();
              }
            })
            .catch((error) => {});
        }
      }
    },

    goToBookingPage() {
      this.$router.push({
        path: "/airfreight/airFreightBooking",
      });
    },

    updateCargo() {
      if (
        this.airPackageModal.packageIdUnit == "0" ||
        this.airPackageModal.packageIdUnit == ""
      ) {
        this.alert.content = "Please Select Package Name";
        this.$refs["addPop1"].open();
        return false;
      }
      if (this.airPackageModal.noOfPackageUnit == "") {
        this.alert.content = "Please Enter No. Of Package";
        this.$refs["addPop1"].open();
        return false;
      }
      if (this.validate != false) {
        let options = {
          method: "POST",

          url: `${URL_BASE}/Api_AirExport/updateShiperCargoDetails.php`,

          data: JSON.stringify(this.airPackageModal),

          crossDomain: true,

          headers: {
            Accept: "application/json",

            "Content-Type": "application/json",

            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const {
              statusText,

              status,

              data,
            } = result;

            if (status == 200 && data) {
              this.counter = 0;

              this.getData();

              this.showPackage = false;

              setTimeout(() => {
                this.validatePackageAtleast();
              }, 1000);
              //  this.airPackageModal.shipperFreightId=''
            }
          })

          .catch((error) => {});
      }
    },

    CommodityCallback(item) {
      this.airFreightModal.commodityId = item.commodityId;
      this.airFreightModal.commodityType = item.commodityType;
      this.airFreightModal.itemDescription = item.itemDescription;
    },

    doLoading() {
      this.isLoading = true;
    },

    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    showMultiple() {
      this.airFreightModal.additionalMoreTask.map((x) => {
        if (x.value == "OthersSpecify") {
          this.showAdd = true;

          return false;
        } else {
          this.showAdd = false;
        }
      });
    },

    getData() {
      this.isLoading = true;
      let array = [];
      let arrayAdditional = [];
      let vehicle_drive = {
        itemCode: "itemCode",

        airFcExportId:
          this.$sessionsStorage.get("editffAirExport") != "" &&
          this.$sessionsStorage.get("editffAirExport") != undefined
            ? this.$sessionsStorage.get("editffAirExport")
            : "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_AirExport/getDataFCLMainAir1.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText,status,data } = result;

          if (status == 200 && data) {
            if (data.airLineList.length > 0) {
              this.airLineList = data.airLineList;
            }
            if (data.airFreightDetail.length > 0) {
              this.showPackageSection = data.airFreightDetail[0].shipmentExecution;
              Object.keys(this.AirFreightMain).map((x) => {
                this.AirFreightMain[x] = data.airFreightDetail[0][x] || "";

                if (x == "jobType") {
                  array = data.airFreightDetail[0][x].split(",");
                }
              });

              this.AirFreightMain["jobType"] = [];

              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);

                i >= 0
                  ? (this.AirFreightMain.jobType[index] = true)
                  : (this.AirFreightMain.jobType[index] = false);
              });
            }

            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }

            if (data.shipperDetail.length > 0) {
              this.allShipperData = data.shipperDetail;
            } else {
              this.allShipperData = [];
            }

            if (data.shipperDetail.length > 0) {
              this.consoMultipleShipperTable = data.shipperDetail;
            } else {
              this.consoMultipleShipperTable = [];
            }

            if (data.packageDetailCargo.length > 0) {
              this.packageDetails = data.packageDetailCargo;

              this.packageDetailsTemp = data.packageDetailCargo;
            } else {
              this.packageDetails = [];
              this.packageDetailsTemp = [];
            }

            if (data.CommodityData.length > 0) {
              this.getCommodityData = data.CommodityData;
            }

            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            }
            console.log(data);
            this.getPortDischargeList = data.LocationDetailsSEAPORT;
            this.PortDestiList = data.LocationDetailsSEAPORT;
            this.finalAllPlaceData = data.LocationDetailsSEAPORT;

            if (data.agentColoaderData.length > 0) {
              this.getagentName = data.agentColoaderData;
            }

            this.AIR_TRACK = data.AIR_TRACK;
            this.AIR_EXEC = data.AIR_EXEC;
            this.AIR_BOOK = data.AIR_BOOK;

            setTimeout(() => {
              this.allFinalWeight();
            }, 2500);
            this.isLoading = false;
          }
        })

        .catch((error) => {});
    },

    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },

    getServicesData() {
      this.showSegmentArray = [
        {
          value: "Freight_Forwarding",
          show: "Freight Forwarding(FF)",
          flex: "20",
        },
        {
          value: "Customs_Clearance",
          show: "Customs Clearance(CC)",
          flex: "20",
        },
        {
          value: "Transportation",
          show: "Transportation(TPT)",
          flex: "20",
        },
        {
          value: "All",
          show: "All",
          flex: "15",
        },
      ];

      this.showOtherServiceArray = [
        {
          value: "Marking",
          show: "Marking/Labelling",
          flex: "20",
        },
        {
          value: "Palletization",
          show: "Palletization",
          flex: "15",
        },
        {
          value: "Fumigation",
          show: "Fumigation",
          flex: "15",
        },
        {
          value: "Lashing",
          show: "Lashing/Choking",
          flex: "20",
        },
        {
          value: "Legalization",
          show: "Legalization",
          flex: "15",
        },
        {
          value: "COC_GSP",
          show: "COC/GSP",
          flex: "15",
        },
        {
          value: "Phyto",
          show: "Phyto",
          flex: "15",
        },
        {
          value: "APEDA",
          show: "APEDA",
          flex: "15",
        },
        {
          value: "HealthCertificate",
          show: "Health Certificate",
          flex: "15",
        },
        {
          value: " WildlifeNOC",
          show: " Wildlife NOC",
          flex: "15",
        },
        {
          value: "OthersSpecify",
          show: " Others Specify",
          flex: "15",
        },
        {
          value: "None",
          show: "None",
          flex: "15",
        },
      ];

      this.showAdditionalMoreTaskArray = [
        {
          value: "Legalization",
          show: "Legalization",
        },
        {
          value: "COC_GSP",
          show: "COC/GSP",
        },
        {
          value: "Phyto",
          show: "Phyto",
        },
        {
          value: "APEDA",
          show: "APEDA",
        },
        {
          value: "HealthCertificate",
          show: "Health Certificate",
        },
        {
          value: " WildlifeNOC",
          show: " Wildlife NOC",
        },
        {
          value: "OthersSpecify",
          show: " Others Specify",
        },
      ];
    },

    removeCommon(item, index) {
      //console.log("Shreshth Gahlot=>",item); return false;
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.isDocActive = item.isActiveCargo == "1" ? 0 : 1;
      let paylod = {
        tableName: "air_cargo_detail",
        tableId: "cargoId",
        tableIsActive: "isActiveCargo",
        value1: this.itemObj.isDocActive,
        tableVal: item.cargoId,
        isMailSend:'No',
        manual:'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// airFFExportConsol.vue?63ff91c0